import { Brand, createBranded } from '@deltasierra/type-utilities';

export type MediaTemplateDocumentLayerId = Brand<string, 'MediaTemplateDocumentLayerId'>;
export const MediaTemplateDocumentLayerId = createBranded<MediaTemplateDocumentLayerId>();
